import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=60e7b188"
import script from "./CartMenu.vue?vue&type=script&lang=js"
export * from "./CartMenu.vue?vue&type=script&lang=js"
import style0 from "./CartMenu.vue?vue&type=style&index=0&id=60e7b188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports